/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { Tooltip } from '../Tooltip/index.js';
export const StepperStep = (props) => {
    const { title, index, currentStepNumber, totalSteps, type, onClick, description, className, style, ...rest } = props;
    const isPast = currentStepNumber > index;
    const isActive = currentStepNumber === index;
    const isClickable = isPast && !!onClick;
    const onCompletedClick = () => {
        if (isClickable) {
            onClick === null || onClick === void 0 ? void 0 : onClick(index);
        }
    };
    const onKeyDown = (e) => {
        if (e.altKey) {
            return;
        }
        if (!isClickable) {
            return;
        }
        if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
            onCompletedClick();
        }
    };
    const stepShape = (React.createElement("li", { className: cx('iui-stepper-step', {
            'iui-current': isActive,
            'iui-clickable': isClickable,
        }, className), style: {
            width: type === 'default' ? `${100 / totalSteps}%` : undefined,
            ...style,
        }, onClick: onCompletedClick, onKeyDown: onKeyDown, "aria-current": isActive ? 'step' : undefined, tabIndex: isClickable ? 0 : undefined, ...rest },
        React.createElement("div", { className: 'iui-stepper-track-content' },
            React.createElement("span", { className: 'iui-stepper-circle' }, index + 1)),
        type === 'default' && (React.createElement("span", { className: 'iui-stepper-step-name' }, title))));
    return description ? (React.createElement(Tooltip, { content: description }, stepShape)) : (stepShape);
};
